import sideBarRightTop from "./units/sideBarRightTop";
import sideBarRightMiddle from "./units/sideBarRightMiddle";
import forumBannerOne from "./units/forumBannerOne";
import forumBannerTwo from "./units/forumBannerTwo";
import video from "./units/video";

const layouts: Layout = {
  forum: {
    mobile: [sideBarRightTop, sideBarRightMiddle, forumBannerOne, forumBannerTwo],
    tablet: [sideBarRightTop, sideBarRightMiddle, forumBannerOne, forumBannerTwo],
    desktop: [sideBarRightTop, sideBarRightMiddle, forumBannerOne, forumBannerTwo]
  },
  comment: {
    mobile: [sideBarRightTop, sideBarRightMiddle, video],
    tablet: [sideBarRightTop, sideBarRightMiddle, video],
    desktop: [sideBarRightTop, sideBarRightMiddle, video]
  },
};

export default layouts;
